import { render, staticRenderFns } from "./TractInformation.vue?vue&type=template&id=8dda32e6&"
import script from "./TractInformation.vue?vue&type=script&lang=js&"
export * from "./TractInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports